import $ from './el.JsModules.js';

const SELECTOR = {
  OVERLAY: '.js-overlay',
  CONTAINER: '.js-content',
  POPOVER: (name) => `[data-centered-popover="${name}"]`,
};

elabs.CenteredPopovers = class {
  'use strict';

  constructor(element) {
    this.view = $(element);
    this.view.css('display', 'flex');
    this.container = this.view.find(SELECTOR.CONTAINER);
    this.overlay = this.view.find(SELECTOR.OVERLAY);

    this.overlay.on('click', () => {
      this.hide();
    });
  }

  //Each CenteredPopovers must have 'show' method
  show({ name, payload = {}, triggerStopScroll = true } = {}) {
    window.CenteredPopovers[name] && window.CenteredPopovers[name]?.show(payload);
    this.activePopover = name;
    this.view.find(SELECTOR.POPOVER(name)).addClass('active');
    this.view.addClass('active');
    this.container.addClass('active');
    triggerStopScroll && this.addBodyClasses();
  }

  //Each CenteredPopovers must have 'hide' method
  hide() {
    setTimeout(() => {
      this.view.find(SELECTOR.POPOVER(this.activePopover)).removeClass('active');
    }, 300);
    this.view.removeClass('active');
    this.container.removeClass('active');
    this.removeClassBodyClasses();
    window.dispatchEvent(new CustomEvent('CenteredPopoversWrapper:hide'));
    window.CenteredPopovers[this.activePopover] && window.CenteredPopovers[this.activePopover]?.hide();
  }

  addBodyClasses() {
    $('body').addClass('overflow-hidden blur-content');
  }

  removeClassBodyClasses() {
    $('body').removeClass('overflow-hidden blur-content');
  }
};

// Initialise all Popovers
elabs.onJavascriptReady(function () {
  //Each popover must extend instance for global access !
  window.CenteredPopovers['wrapper'] = new elabs.CenteredPopovers($('#ElCenteredPopovers'));
  window.__CenteredPopoversWrapperReady = true;
  window.dispatchEvent(new CustomEvent('CenteredPopoversWrapper:ready'));
});
